import getBasePath from '../functions/api-resource';

const basePath = getBasePath('workflow_tatico', 'execucao/planejamento-tatico');

const workflowPlanejamento = {
  statusPasso: { method: 'GET', url: `${basePath}/{idPlanejamento}/passos/status` },
};

export default (resource) => resource(`${basePath}`, {}, workflowPlanejamento);
